import { useTranslation } from "react-i18next";
import { buildPath } from "./lib/route";
import HeroReadout from "./components/HeroReadout";
import TopBar from "./components/TopBar";
import Wizard from "./features/wizard/Wizard";
import { WizardProvider } from "./features/wizard/WizardContext";

export default function App() {
  const { t, i18n } = useTranslation();
  const language = i18n.language.startsWith("en") ? "en" : "da";
  return (
    <WizardProvider>
      <TopBar />
      <main className="mx-auto max-w-wrap px-7">
        <section className="pb-2 pt-14">
          <h1 className="max-w-[14ch] text-balance text-[clamp(38px,7.2vw,76px)] leading-[0.98] tracking-[-0.025em]">
            {t("hero.h1a")}
            <span className="bg-gradient-to-b from-transparent from-[62%] to-accent-tint to-[62%] px-[0.05em]">{t("hero.h1mark")}</span>
            {t("hero.h1b")}
            <em className="italic text-accent-deep">{t("hero.h1em")}</em>
          </h1>
          <p className="mt-5 max-w-[46ch] text-[clamp(16px,2.2vw,19px)] text-ink-soft">{t("hero.sub")}</p>
          <HeroReadout />
        </section>

        <Wizard />
      </main>

      <footer className="border-t border-line py-9">
        <div className="mx-auto flex max-w-wrap flex-col gap-4 px-7 sm:flex-row sm:items-center sm:justify-between sm:gap-8">
          <span className="font-ui text-[15px] font-semibold text-ink">Biloplader<span className="text-accent-deep">.dk</span></span>
          <a
            href={buildPath("providerIndex", language)}
            className="font-mono text-[10.5px] uppercase tracking-[0.14em] text-ink-faint underline-offset-4 hover:text-ink hover:underline"
          >
            {t("udbyder.indeks.titel")}
          </a>
          <span className="font-mono text-[10.5px] uppercase tracking-[0.14em] text-ink-faint">{t("foot")}</span>
          <span className="max-w-[40ch] text-[12.5px] leading-relaxed text-ink-faint">{t("a11y.beta")}</span>
        </div>
      </footer>
    </WizardProvider>
  );
}
